export enum ViaductAction {
  UserPrompt = "userprompt",
}

export interface ViaductLinkData {
  linkText: string;
  action: ViaductAction;
  actionParameter: string;
}

export const ViaductLinkRegex =
  /\[([^\]]+)\]\(viaduct\+([a-zA-Z0-9]+):\/\/duck\.link\?([^)\s]+)\)/;
